import { useCallback, useMemo } from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';

import styles from './GoogleButton.module.scss';

interface Props {
  googleLogin: () => void;
  text?: 'signup' | 'login';
}

interface OAuthProviderProps {
  clientId: string;
}

const GoogleButton: React.FC<Props> = ({ googleLogin: login, text = 'login' }) => {
  const handleClick = useCallback(
    (event: React.SyntheticEvent<HTMLButtonElement>) => {
      event.preventDefault();
      login();
    },
    [login]
  );
  const displayText = useMemo(() => (text === 'login' ? 'Googleでログイン' : 'Googleで登録'), [
    text,
  ]);
  return (
    <button type="button" className={styles['google-button']} onClick={handleClick}>
      <div className={styles['icon']}>
        <img alt={displayText} src="/static/images/social/google-icon.svg"></img>
      </div>
      <span>{displayText}</span>
    </button>
  );
};

const GoogleLoginWithOAuthProvider: React.FC<OAuthProviderProps & Props> = ({
  clientId,
  googleLogin,
  text,
}) => (
  <GoogleOAuthProvider clientId={clientId}>
    <GoogleButton googleLogin={googleLogin} text={text} />
  </GoogleOAuthProvider>
);

export { GoogleButton };

export type { Props as GoogleButtonFCProps };
export default GoogleLoginWithOAuthProvider;
